import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { captchaSettings } from 'reactjs-captcha'; 

export default class App extends Component {
  static displayName = App.name;

    constructor(props) {
        super(props);

        captchaSettings.set({
            captchaEndpoint:
                '/contact/simple-captcha-endpoint.ashx'
        });
    }

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js